import './home2050.less'

import {Image, m, Picture, wrap} from '@codeurs/front'
import Iceberg from 'assets/images/iceberg.png'
import React, {Component} from 'react'
import {
	BlocksData,
	CardData,
	ImageType,
	PageData,
	PaginationResult,
	WysiwygType
} from 'types'
import {style} from 'util/style'
import {Layout2050} from 'views/layout2050'
import {HeaderPortal} from 'views/partials/header'
import {Hero} from 'views/partials/hero'
import {Theme} from 'views/theme'
import {Blocks} from '../blocks/blocks'

export type Home2050Type = {}

const styles = style('home2050')

@wrap(Layout2050)
export class Home2050 extends Component<{
	data: PageData &
		BlocksData & {
			articles: PaginationResult<CardData>
			featured: CardData
			newsletter: {
				title: string
				text: string
				placeholder: string
				agree: string
				thanks: string
			}
			page_title: string
			intro: WysiwygType
			quote_right: string
			image: ImageType
			text: WysiwygType
			quote_left: string
		}
}> {
	render() {
		const {
			page_title,
			intro,
			quote_right,
			image,
			text,
			quote_left,
			blocks,
			id
		} = this.props.data
		return (
			<div class={styles}>
				<Theme.Container class={styles('container')}>
					<HeaderPortal>
						<Hero hero={true}>
							<Theme.H1>{page_title}</Theme.H1>
						</Hero>
					</HeaderPortal>
					<div class={styles('intro-column')}>
						<Theme.Wysiwyg class={styles('intro-text')}>{intro}</Theme.Wysiwyg>
						<div class={styles('quote-right')}>
							<div class={styles('quote')}>{quote_right}</div>
						</div>
					</div>
					<div class={styles('intro-column')}>
						<div>
							<div class={styles('intro-image')}>
								<Image {...image} />
							</div>
						</div>
						<div class={styles('intro-content')}>
							<Theme.Wysiwyg class={styles('intro-content-text')}>
								{text}
							</Theme.Wysiwyg>
							<div class={styles('quote-block')}>
								<div class={styles('quote')}>{quote_left}</div>
								<div class={styles('quote-image')}>
									<Image {...Iceberg} />
								</div>
							</div>
						</div>
					</div>
				</Theme.Container>
				<div class={styles('separator')} />
				<Theme.Container>
					{blocks && blocks.length > 0 && (
						<div class={styles('content-blocks')}>
							<Blocks blocks={blocks} pageId={id} wide={true} />
						</div>
					)}
				</Theme.Container>
			</div>
		)
	}
}
